import React, {useState} from "react";
import Modal from "react-modal";
import XMultiplierCalculator from "./XMultiplierCalculator";
import BurnCalculator from "./BornCalculator";
import APYCalculator from "./ApyCalculator";
import VolumeCalculator from "./VolumeCalculator";
import Web3 from "web3";
import Token from '../../abi/Ufo.json';
import Staking from '../../abi/Staking.json';
import { providerURL } from '../../../../helper/Helper';

const CalculatorPopup = ({ modalIsOpen, closeModal, volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually, ufoPrice}) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const handleTabClick = (tab) => {setActiveTab(tab);};
  const [burnBalance, setBurnBalance] = useState(0);
  const [selfBalance, setSelfBalance] = useState(0);
  const [lpBalance, setLPBalance] = useState(0);
  const [staked, setStaked] = useState(0);

  const handleModalOpen = async () => {
    const web3 = new Web3(providerURL());
    const UFOContract = new web3.eth.Contract(Token.ABI, Token.Contract);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);

    setBurnBalance(parseInt(await UFOContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    setSelfBalance(parseInt(await UFOContract.methods.balanceOf('0x456548A9B56eFBbD89Ca0309edd17a9E20b04018').call()) / 10**18);
    setStaked(parseInt(await stakingContract.methods.UFOStaked().call()) / 10**18);

    setLPBalance(
      parseInt(await UFOContract.methods.balanceOf('0xbea0e55b82eb975280041f3b49c4d0bd937b72d5').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x5b002c8ad3c23b4021f75003fecf01a10b11f6ca').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x31c77e0519a0347aa547aeab6e866c30a1a32123').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x2cabcba08e69449f9acf3dd69f7a7cd2f9ddc0db').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x3ed0e39d9de5341ac511249517099c3e5d8b92bf').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0xd3a87bda2238ee28b424d38991df1fbadd2be666').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x1f2fa0f2cd4f603878d46d979370f82a91715fcc').call()) / 10**18 
    );

  };
  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal" onAfterOpen={handleModalOpen}>
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="UFOSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont">Calculator</h2>
            </div>
              <div className="row justify-content-center mt-4">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="d-flex justify-content-center ">
                    <ul className="nav nav-pills mb-1 gap-1" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`} onClick={() => handleTabClick('tab1')} id="pills-tab1-tab" type="button" role="tab" aria-controls="pills-tab1" aria-selected={activeTab === 'tab1'}>X Multiplier</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab2' ? 'active' : ''}`} onClick={() => handleTabClick('tab2')} id="pills-tab2-tab" type="button" role="tab" aria-controls="pills-tab2" aria-selected={activeTab === 'tab2'}>Burn</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`} onClick={() => handleTabClick('tab3')} id="pills-tab3-tab" type="button" role="tab" aria-controls="pills-tab3" aria-selected={activeTab === 'tab3'}>Reward</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab4' ? 'active' : ''}`} onClick={() => handleTabClick('tab4')} id="pills-tab4-tab" type="button" role="tab" aria-controls="pills-tab4" aria-selected={activeTab === 'tab4'}>Volume</button>
                    </li>
                  </ul>
                </div>
                <div className="stakeSec  tab-content" id="pills-tabContent">
                  <div className={`tab-pane fade ${activeTab === 'tab1' ? 'show active' : ''}`} id="pills-tab1" role="tabpanel" aria-labelledby="pills-tab1-tab">
                    <XMultiplierCalculator/>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'tab2' ? 'show active' : ''}`} id="pills-tab2" role="tabpanel" aria-labelledby="pills-tab2-tab">
                    <BurnCalculator volumeDaily={volumeDaily}/>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'tab3' ? 'show active' : ''}`} id="pills-tab3" role="tabpanel" aria-labelledby="pills-tab3-tab">
                    <APYCalculator burnBalance={burnBalance} selfBalance={selfBalance} lpBalance={lpBalance} staked={staked} ufoPrice={ufoPrice}/>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'tab4' ? 'show active' : ''}`} id="pills-tab4" role="tabpanel" aria-labelledby="pills-tab4-tab">
                    <VolumeCalculator volumeDaily={volumeDaily}/>
                  </div>
                </div>
              </div>
            </div>
         </div>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default CalculatorPopup;